<template>
  <document-card
    v-if="document"
    class="m-bottom-20"
    :id="documentId"
  ></document-card>

  <div class="max-width-500 is-margin-auto">
    <edit-infos
      v-if="document"
      :id="documentId"
      :document="document"
    ></edit-infos>
  </div>

  <span></span>
</template>

<script>
  import { computed, ref } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'
  import useRoles from '@composables/use-roles'
  import EditInfos from '@components/documents/edition/edit-infos'
  import DocumentCard from '@components/documents/view/document-card'

  export default {
    setup () {
      const userId = computed(() => router.currentRoute.value.params.id)
      const { get, fetch } = useStore('@freebe/documents')
      const { checkPermissions } = useRoles()

      if (!checkPermissions('freebe/documents:get')) {
        router.replace({ 
          name: 'user-documents',
          params: {
            id: userId.value
          } 
        })
      }

      const documentId = computed(() => 
        router.currentRoute.value.params.document_id
      )
      let document = computed(() => get(documentId.value))

      if (!document.value && documentId.value) {
        fetch(documentId.value)
      }

      return {
        document,
        documentId,
      }
    },

    components: {
      EditInfos,
      DocumentCard
    },
  }
</script>

